export function validateIdentity(values, phoneRequired = false) {
    const errors = {};
    if (!values.souhlas) errors.souhlas = 'Potvrďte seznámení s podmínkami a informacemi o zpracování údajů.';
    if (!values.firstName || !values.firstName.trim() || values.firstName.trim().length > 80) errors.firstName = 'Zadejte jméno (max. 80 znaků).';
    if (!values.lastName || !values.lastName.trim() || values.lastName.trim().length > 100) errors.lastName = 'Zadejte příjmení (max. 100 znaků).';
    if (!values.email || values.email.length > 254 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email.trim())) errors.email = 'Zadejte platný e-mail.';
    if ((phoneRequired || values.tel) && (!values.tel || values.tel.length > 40 || !/^\+?[\d\s().-]{9,40}$/.test(values.tel.trim()) || values.tel.replace(/\D/g, '').length < 9)) errors.tel = 'Zadejte platný telefon.';
    if (!values.captcharesponse) errors.captcharesponse = 'Prosím ověřte, že nejste robot.';
    return errors;
}

export function validateLocation(values, addressRequired = false) {
    const errors = {};
    if (!values.zip || !/^\d{3} ?\d{2}$/.test(values.zip.trim())) errors.zip = 'Zadejte platné PSČ.';
    if (values.city && values.city.trim().length > 120) errors.city = 'Město je příliš dlouhé.';
    if (addressRequired && (!values.adress || !values.adress.trim() || values.adress.trim().length > 250)) errors.adress = 'Zadejte adresu (max. 250 znaků).';
    return errors;
}
